import React from "react";
import BrowserService from "../../../../services/Browser";
import Error from "../../../common/Error";
import Loader from "../../../common/Loader";
import { DurationOptions } from "../Dashboard/Graphs/DurationSelector/constants";
import { getDurationFromTimeRange } from "../Dashboard/Graphs/DurationSelector/utils";
import BrowserOptions from "./BrowserOptions";
import { SourceOptions } from "./BrowserOptions/constants";
import BrowserTable from "./BrowserTable";
import { StockBrowserContainer, ErrorContainer } from "./styles";

const pageSize = 100;

function StockBrowser() {
  const [filters, setFilters] = React.useState({
    timeRange: "day",
    sortBy: {
      field: "mentions",
      order: "DESC",
    },
  });
  let [source, setSource] = React.useState(SourceOptions[0].value);
  const [filterLock, setFilterLock] = React.useState(true);
  const [rows, setRows] = React.useState([]);
  const [mentionsChangePositiveRatio, setPriceChangePositiveRatio] =
    React.useState(0.5);
  const [sentimentPositiveRatio, setSentimentPositiveRatio] =
    React.useState(0.5);
  const [pageNumber, setPageNumber] = React.useState(0);

  React.useEffect(() => {
    setFilterLock(true);
    console.log("Fetching for pageNumber : ",pageNumber);

    if(pageNumber === 0){
      setRows([])
    }
    let service;
    if (source == SourceOptions[1].value) {
      service = BrowserService.getPennystocksTrending;
    } else {
      service = BrowserService.getAllTrending;
    }
    
    service({ ...filters, pageNumber, pageSize })
      .then((data) => {
        console.log("Got data.");
        if(pageNumber === 0){
          setPriceChangePositiveRatio(data.mentionsChangePositiveRatio);
          setSentimentPositiveRatio(data.sentimentPositiveRatio);
          setRows(data.rows);
          console.log("First Page. Hence setting everything");
        }
        else{
          setRows([...rows, data.rows]);
          console.log("Not the first page.")
        }
        if(pageNumber === Math.ceil(100/ pageSize) -1 ){
          setFilterLock(false);
          console.log("The last page. Hence removing the lock.")
        }
        else{
          setPageNumber(pageNumber + 1);
          console.log("Not the last page. Hence checking page "+pageNumber+1)
        }
      })
      .catch((e) => {
        setFilterLock(false);
        if (e?.response?.data) {
          setRows(e.response.data.message || e.response.data.detail);
        } else {
          setRows(e.message || "Failed to load data");
        }
      });
  }, [filters,pageNumber, source]);
  // React.useEffect(() => {
  //   // setPageNumber(0);
  //   setRows([]);
  // }, [filters, source]);
  return (
    <StockBrowserContainer>
      <BrowserOptions
        filters={filters}
        setFilters={setFilters}
        filterLock={filterLock}
        source={source}
        setSource={setSource}
      />
      {rows?.length === 0 ? (
        <ErrorContainer>
          <Loader text={"Loading Trending Stocks for "+DurationOptions[getDurationFromTimeRange(filters.timeRange)].durationText} />
        </ErrorContainer>
      ) : !rows || rows === undefined || typeof rows === "string" ? (
        <ErrorContainer>
          <Error
            text={
              "Failed to load stocks. " +
              (rows === undefined ? "Try refreshing the page." : rows)
            }
          />
        </ErrorContainer>
      ) : (
        <BrowserTable
          rows={rows}
          mentionsChangePositiveRatio={mentionsChangePositiveRatio}
          sentimentPositiveRatio={sentimentPositiveRatio}
        />
      )}
    </StockBrowserContainer>
  );
}
export default StockBrowser;
